import React from 'react';
import {
  Button, Box, Container, Typography, Stack,
} from '@mui/material';
import { Link } from 'react-router-dom';
import Bottle from '../../assets/png/bottle.png';

const TripReviewGiftView = () => (
  <Container maxWidth="md" sx={{ my: 10 }}>
    <Stack spacing={2}>
      <Typography variant="h2">Thank you for your review!</Typography>
      <Typography>
        As a token of our appreciation,
        we&apos;d like to send you a premium 20 oz water bottle with a laser-engraved Zicasso logo.
        It&apos;s made with safe, BPA-free materials,
        has a food-safe stainless steel interior, and is dishwasher-friendly.
      </Typography>

      <Box
        component="img"
        src={Bottle}
        sx={{
          maxHeight: 300,
          width: '100%',
          objectFit: 'contain',
          transform: 'rotate(45deg)',
          userSelect: 'none',
        }}
      />

      <Stack
        spacing={2.5}
        alignSelf={{
          mobile: 'initial',
          desktop: 'flex-start',
        }}
        direction={{
          mobile: 'column',
          desktop: 'row',
        }}
      >
        <Button
          component={Link}
          relative="path"
          to="../submit"
          variant="outlined"
          sx={{
            width: {
              desktop: 'fit-content',
            },
          }}
        >
          No Thanks
        </Button>

        <Button
          component={Link}
          to="./form"
          variant="contained"
          sx={{
            width: {
              desktop: 'fit-content',
            },
          }}
        >
          Send me a Gift
        </Button>
      </Stack>
    </Stack>
  </Container>
);

export default TripReviewGiftView;
